import styled from "styled-components";
// import { BannerBg } from "../../../ui/AllImages";
import Cookies from "js-cookie";
import { ContactBg } from "../../../ui/AllImages";

export const ContactWrapper = styled.section`
    padding-top: 90px;
    /* padding-bottom: 72px; */
    background-image: url(${ContactBg});
    background-size: cover;
    background-repeat: no-repeat;
    & > *{
        position: relative;
        z-index: 5;
    }
    .contect-with-us{
        display: block;
        width: 100%;
        /* background-color: var(--bg2); */
        border-radius: 16px;
        padding: 0px 0px 0px 20px;
    }
    .contactComBox{
        padding-top: 12px;
        padding-bottom: 12px;
        border-bottom: 1px solid #4092FF;
        &.no-border{
            border-bottom: none;
        }
    }
    .contactComBoxSocial{
        display: flex;
        justify-content: space-between;
        position: absolute;
        bottom: 40px;
        left: 40px;
        right: 40px;
        padding-bottom: 0;
        align-items: center;
    }
    
    .contactDetailCol{
        display: block;
        width: 100%;
        background-color: rgba(64, 146, 255, .4);
        backdrop-filter: blur(10px);
        -webkit-backdrop-filter: blur(10px);
        border: 1px solid #5aa1ff;
        border-radius: 16px;
        padding: 30px 40px 40px 40px;
        height: 491px;
    }
    .contactComHeading{
        display: flex;
        width: 100%; 
        font-size: 24px;
        color: var(--bg2);
        font-family: var(--medium);
        line-height: 1;
        padding-bottom: 16px;
    }
    .contactText{
        padding: 0 70px 0 70px;
    }
    .contact-text{
        font-family: var(--medium);
        color: var(--bg2);
    }
    .contact-info{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 15px;
        & > *{
            width: 100%;
        }
    }
        
    .followHeading{
        margin-top: 30px;
    }
    .addrTxt{
        padding-right: 50px;
    }
    /* .btn-text{
        background: var(--gradient);
        padding: 8px 12px;
        border-radius: 8px;
        & div{
            color:var(--white);
        }
        // & svg{
        //     [fill]{
        //         fill:var(--white);
        //     }
        // }
    } */
    .contactHContainer{
        padding-bottom: 50px;
    }
    .contact-svg{
        /* width: 32px;
        height: 32px;
        background-color: var(--themeColor);
        border-radius: 8px; */

        svg{
            margin: auto;
        }
    }
    .contact-info button,
    .cInfoIt{
        gap: 12px;
        padding: 0;
    }
    
    .contact-wrapper{
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 10px;
        position: relative;
        padding:20px 20px;
    }
    .Social-links{
        display: flex;
        /* width: 100%; */
        gap: 12px;
    }
    .contact-links{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        /* background-color: var(--themeColor); */
        /* border-radius: 8px; */
    }
    .containerContact{
        border-bottom: 1px solid #4092FF;
        padding-bottom: 40px;
    }
    
    body.rtl &{
        /* padding-top: 70px; */
        /* .contact-Us-detail{
            order: 2;
        }
        .contact-Us{
            order: 1;
        } */
        .addrTxt {
            padding-left: 50px;
            padding-right: 0;
        }
        .contactComHeading{
            font-family: var(--arRegular);
        }
        .contactComBox{
            span{
                font-family: var(--arRegular);
            }
        }
        .contactdesc{
            font-size: 19px;
            line-height: 1.7;
            font-family: var(--arMedium);
        }
        .Social-links{
            svg{
                -webkit-transform: scaleX(1) !important;
                -moz-transform: scaleX(1) !important;
                -o-transform: scaleX(1) !important;
                transform: scaleX(1) !important;
            }
        }
        .contactDetailCol{
            height: 520px;
        }
    } 
    @media (max-width: 991px) {
        .containerContact > .row{
            gap: 30px;
        }
        .contactDetailCol{
            height: auto;
        }
        .contactComBoxSocial{
            position: relative;
            right: unset;
            left: unset;
            bottom: unset;
            padding-top: 20px;
        }
        .contect-with-us {
            padding: 25px 0px 25px 0px;
        }
        body.rtl &{
            .contactDetailCol{
            height: auto;
        }
            /* .contact-Us-detail{
                order: 1;
            }
            .contact-Us{
                order: 2;
            } */
        }
    }
    @media (max-width: 767px) {
        padding-top: 70px;
        .contect-with-us {
            /* padding: 25px 20px 25px 20px; */
        }
    }
    @media (max-width: 640px) {
        .contactDetailCol {
            padding: 20px 15px 30px 15px;
            .contactComBox.no-border:not(.contactComBoxSocial.no-border){
                padding-top: 0;
            }
        }
    }
    @media (max-width: 420px) {
        .contactComBoxSocial{
            flex-wrap: wrap;
            gap: 15px;
        }
    }
    
    
`
export const ContactFormWrapper = styled.div`
    .field-box{
        display: flex;
        flex-direction: column;
        gap:2px;
        margin:0px 0 15px 0;
        
    }
    .input-field,
    .file-attached{
        padding: 11px 15px;
        border-radius: 16px;
        border: none;
        outline: none;
        color: var(--white);
        background-color: rgba(64, 146, 255, .4);
        backdrop-filter: blur(10px);
        -webkit-backdrop-filter: blur(10px);
        border: 1px solid #5aa1ff;
        font-size: 16px;
        font-family: var(--regular);
        
    }

    .input-field::placeholder{
        color:var(--textPalceholder);
    }
    .error-message{
        font-family: var(--regular);
        /* border: 1px solid #ff00004f; */
        color: #d40404 !important;
        /* padding: 6px 8px; */
        font-size: 14px;
        margin-bottom: 0;
        /* background: #ff00004f; */
        /* -webkit-text-fill-color: white; */
    }
    .loading-btn{
        position: absolute;
        left: 0;
        right: 0;
        width: 100%;
        height: 100%;
        z-index: 10;
        background: #0b0b0b9c;
        text-align: center;
        top: 0;
        bottom: 0;
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        color:var(--white);
        font-family:var(--regular);
        border-radius: 28px;

    }
    .contact-social-links{
        position: relative;
        left: 15px;
    }
    .contactBtn{
        display: flex;
        background-color: var(--themeColor);
        padding: 11px 30px;
        border-radius: 10px;
        color: var(--white);
        font-size: 17px;
        font-family: var(--bold);
        transition: all .4s ease-in-out;
        border: none;
        &:hover{
            background-color: var(--hoverBg);
            border: none;
        }
    }
    body.rtl &{
        .input-field,
        .file-attached{
            font-family: var(--arLT);
        }
        .field-box p{
            font-family: var(--arLT);
        }
        .Toastify__toast{
            font-family: var(--arLT);
        }
        .Toastify__close-button{
            left: 6px;
            right: auto;
        }
    }
    @media (max-width: 767px) {
        .field-box{
            margin:0px 0 5px 0;
        }
        .contact-btn{
            margin-bottom: 0 !important;
        }
    }
`